import React, { useState } from "react";

// table(components)
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
// import { PageOptions } from '../components/PageParams';
import cellEditFactory from "react-bootstrap-table2-editor";
import styled from "styled-components";
import {
  FormatCurrency,
  GetHeaderStyle,
  getCellStyle,
} from "../../core/Helper";
import "./style.css";

export default function StudyItems(props) {
  const [data, setData] = props.priceData;

  /** --------------------------------------------------------------- */
  const actionPriceChange = async (oldValue, newValue, row, column, done) => {
    row.total = newValue * row.price;
    done();
  };
  /** --------------------------------------------------------------- */
  const formatCurrency = (col, row) => {
    return FormatCurrency(col);
  };
  /** --------------------------------------------------------------- */
  const fontName = "tahoma";
  const fontSize = "14px";
  const columns = [
    {
      dataField: "goodcode",
      text: "รหัส",
      sort: true,
      headerStyle: () => GetHeaderStyle("180px"),
      style: getCellStyle("center", null, fontSize, fontName),
      headerSortingStyle: { border: "none" },
      editable: false,
    },
    {
      dataField: "goodname",
      text: "รายการตรวจ/เวชภัณฑ์",
      sort: true,
      headerStyle: GetHeaderStyle("auto", "left"),
      style: getCellStyle("left", null, fontSize, fontName),
      editable: false,
    },
    // {
    //   dataField: "qty",
    //   text: "QTY",
    //   sort: true,
    //   headerStyle: GetHeaderStyle("50px"),
    //   style: {
    //     border: "none",
    //     color: "var(--table-text-color)",
    //     textAlign: "center",
    //   },
    //   editable: false,
    // },
    {
      dataField: "price_df",
      text: "DF",
      sort: false,
      headerStyle: GetHeaderStyle("150px", "center"),
      style: getCellStyle("center", null, fontSize, fontName),
      editable: false,
      formatter: formatCurrency,
    },
    // {
    //   dataField: "total",
    //   text: "รวม",
    //   sort: true,
    //   headerStyle: GetHeaderStyle("100px"),
    //   style: {
    //     border: "none",
    //     color: "var(--table-text-color)",
    //     textAlign: "right",
    //   },
    //   editable: false,
    //   formatter: formatCurrency,
    // },
  ];

  /** --------------------------------------------------------------- */
  return (
    <div>
      <BoostrapTable
        bootstrap4
        keyField="price_list_det_id"
        data={data && data}
        rowClasses={"table-next-rows-style"}
        columns={columns}
        striped
        hover
        condensed
        headerWrapperClasses="table-radi-result-wrapper"
        headerClass="table-radi-result-header"
        wrapperClasses="table-radi-result-wrapper"
        bordered={true}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          beforeSaveCell: actionPriceChange,
        })}
      />
    </div>
  );
}
